import { default as Box } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const SizedBox = styled(Box)(() => ({
  maxWidth: '300px'
}));
